import React from "react";
import PropTypes from "prop-types";
import CustomeButton from "~/components/Button";
import { useNavigate, useParams } from "react-router-dom";
import PermissionGate from "~/components/PermissionGate";
export default function EmptyDataView({
  Icon,
  Header,
  Description,
  type,
  handleNavigate,
}) {
  const navigate = useNavigate();
  const { id: entityId } = useParams();
  return (
    <div className="flex flex-column justify-content-center align-items-center p-5 empty__data__view">
      {Icon && <div className="empty__data__view--icon">{Icon}</div>}
      {Header && <p className="empty__data__view--header">{Header}</p>}
      {Description && (
        <p className="empty__data__view--description">{Description}</p>
      )}
      <PermissionGate
        resource="officer"
        action="modify"
        resourceAttr={{ entity_id: entityId }}
      >
        <CustomeButton
          label={type === "officer" ? "Add Officer" : "Add Attorney"}
          className="access-btn"
          icon="pi pi-plus"
          iconPos="right"
          onClick={handleNavigate}
        />
      </PermissionGate>
    </div>
  );
}
EmptyDataView.propTypes = {
  Icon: PropTypes.node,
  Header: PropTypes.string,
  Description: PropTypes.node,
};
